<div *ngIf="fieldOptions?.displayType !== 'PublicRecord'"
     class="myField {{highlight}}"
     [ngClass]="{
        'highlight': active,
        'd-inline-block': !show.label,
        'd-block': (show.value && fieldOptions?.cssClass !== 'd-inline-block')
    }">

    <h6 *ngIf="show?.label === true"
        [ngClass]="{
            'required': fieldOptions?.required == true
        }">
        {{field?.UILabel || field?.DisplayText || 'No title'}}
        <span>
            <button *ngIf="historical.length"
                    #changesEl
                    class="btn btn-sm cv-btn-revised_fields"
                    (click)="showHistorical()">
                <i class="fas fa-book"></i>
                <span>{{ historical.length }}</span>
            </button>
        </span>
        <span *ngIf="fieldOptions.publicRecordMultiple === 'single'">
            <i class="fa fa-info-circle "
               data-toggle="tooltip"
               data-placement="top"
               [title]="'Autofilled from public records'"></i>
        </span>
    </h6>

    <div *ngIf="show?.label === false">
        <button *ngIf="historical.length"
                #changesEl
                class="btn btn-sm cv-btn-revised_fields"
                (click)="showHistorical()">
            <i class="fas fa-book"></i>
            <span>{{ historical.length }}</span>
        </button>
    </div>

    <ng-container *ngIf="fieldOptions.isDropdown && control" >
        <cv-dropdown
            [placeholder]="'Select a ' + fieldOptions.label"
            [options]="fieldOptions.listItems"
			[optionText]="fieldOptions.optionText"
			[optionValue]="fieldOptions.optionValue"
			[selectedValue]="fieldOptions.listItems.length > 0 ? getSelectedDropDown() : selectedDropdownValue"
            (valuesChange)="selectedOption($event)"
        ></cv-dropdown>
    </ng-container>



    <div *ngIf="fieldOptions?.displayType !== 'map' && show.value && field && !fieldOptions.isDropdown">
        <div class="form-group input-group ">
            <ng-container [ngSwitch]="field.DataType">
                <span *ngIf="fieldOptions.prefix"
                      [ngClass]="{'single-field single-field-prefix': fieldOptions.publicRecordMultiple === 'single'}"
                      class="input-group-text">
                    {{fieldOptions.prefix}}
                </span>

                <ng-container
                              *ngSwitchCase="field.DataType === 'Enumerated' || field.DataType === 'Enumeration' ? field.DataType : '' ">
                    <cv-cascader [items]="field.Enumeration"
                                 [configOptions]="{
                                     value: 'Key',
                                     text: 'Value',
                                     children: 'Children'
                                }"
                                 placeholder="Select an option"
                                 [value]="control.value"
                                 [valid]="!(this.control.touched && this.control.invalid)"
                                 [disabled]="false"
                                 [indexTab]="indexTab"
                                 (valueChange)="cascadeChanged($event)">
                    </cv-cascader>
                </ng-container>

                <ng-container *ngSwitchCase="'Boolean'">
                    <div class="container-boolean">
                        <cv-switch class="primary"
                                   size="sm"
                                   [checked]="control.value"
                                   [indexTab]="indexTab"
                                   (valueChange)="onSwitchChange($event)">
                        </cv-switch>
                        <label class="boolean-text">{{control.value ? 'Yes' : 'No'}}</label>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'bool-with-value'">
                    <div class="item-checkbox">
                        <input [attr.tabindex]="indexTab"
                               class="form-check-input"
                               type="checkbox"
                               [formControl]="control"
                               id="{{temporalInputId}}checkbox{{field.Value}}">
                        <label class="form-check-label"
                               for="{{temporalInputId}}checkbox{{field.Value}}">
                            {{field.DisplayText}}
                        </label>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'String'">
                    <ng-container *ngIf="field.UIControl">
                        <textarea [attr.tabindex]="indexTab"
                                  class="form-control"
                                  rows="5"
                                  [formControl]="control"
                                  (blur)="onChange($event)"
                                  (keyup)="onKeyup($event)">
                        </textarea>
                    </ng-container>
                    <ng-container *ngIf="!field.UIControl">
                        <input [attr.tabindex]="indexTab"
                               type="text"
                               class="form-control"
                               [formControl]="control"
                               (blur)="onChange($event)"
                               (keyup)="onKeyup($event)">
                    </ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'Text'">
                    <textarea [attr.tabindex]="indexTab"
                              class="form-control"
                              rows="5"
                              [formControl]="control"
                              (blur)="onChange($event)"
                              (keyup)="onKeyup($event)">
                    </textarea>
                </ng-container>

                <ng-container *ngSwitchCase="['Integer', 'Numeric'].includes(field.DataType) ? field.DataType : ''">
                    <input class="form-control"
                           type="number"
                           [min]="min"
                           [max]="max"
                           [formControl]="control"
                           (blur)="onChange($event)"
                           (keydown)="onKeyDownNumeric($event)"
                           [attr.tabindex]="indexTab"
                           [ngClass]="{
                               'form-control-with-postfix': fieldOptions.postfix,
                               'form-control-with-prefix': fieldOptions.prefix,
                               'single-field': fieldOptions.publicRecordMultiple === 'single'
                            }" />
                </ng-container>

                <ng-container *ngSwitchDefault>
                    <input [attr.tabindex]="indexTab"
                           type="text"
                           class="form-control"
                           [formControl]="control"
                           (blur)="onChange($event)"
                           (keyup)="onKeyup($event)">
                </ng-container>

                <span *ngIf="fieldOptions.postfix"
                      [ngClass]="{'single-field single-field-postfix': fieldOptions.publicRecordMultiple === 'single'}"
                      class="input-group-text">
                    {{fieldOptions.postfix}}
                </span>
            </ng-container>

        </div>
    </div>
    <div>

    </div>
</div>
